import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class SendToBackAction extends AbstractProvidedClass {
    constructor(provider, element) {
        super(provider);
        this.element = element;
        this.oldIndex = this.elements.indexOf(element);
        this.newIndex = 0;
    }

    finish() {
        // If the element is already at the back, discard the action
        if (this.oldIndex == 0) {
            this.actions.discard();
            return;
        }
        this.elements.move(this.oldIndex, this.newIndex);
        this.actions.finish();
    }

    undo() {
        this.elements.move(this.newIndex, this.oldIndex);
    }

    redo() {
        this.elements.move(this.oldIndex, this.newIndex);
    }
}
